<template>
    <div>
        <div v-if="carregando" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else class="u-mt-20" style="padding: 20px 12px;">
            <h4><i class="el-icon-notebook-2"></i> Acompanhamento pedagógico</h4>
            <p style="color:#909399;">
                Aqui aparecem os planos e registros de acompanhamento que a escola liberou
                para a família.
            </p>

            <el-alert v-if="erro" type="warning" :closable="false" class="u-mb-15" :title="erro"></el-alert>

            <el-table v-else :data="itens" stripe style="width: 100%;"
                empty-text="Nenhum acompanhamento disponível no momento.">
                <el-table-column label="Data" width="120">
                    <template slot-scope="scope">{{ formatarData(scope.row.data) }}</template>
                </el-table-column>
                <el-table-column label="Tipo" min-width="220">
                    <template slot-scope="scope">{{ scope.row.rotulo }}</template>
                </el-table-column>
                <el-table-column label="Informações" min-width="300">
                    <template slot-scope="scope">
                        <div v-if="scope.row.conteudo && scope.row.conteudo.resultado">
                            {{ scope.row.conteudo.resultado }}
                        </div>
                        <div v-else-if="scope.row.conteudo && scope.row.conteudo.ano">
                            Referente ao ano de {{ scope.row.conteudo.ano }}<span v-if="scope.row.conteudo.finalizado"> · concluído</span>.
                        </div>
                        <div v-else style="color:#909399;">
                            Registro disponível na escola. Procure a coordenação para mais detalhes.
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Publicado em" width="150">
                    <template slot-scope="scope">{{ formatarDataHora(scope.row.publicado_em) }}</template>
                </el-table-column>
            </el-table>

            <p v-if="!erro" style="color:#909399; font-size: 12px; margin-top: 14px;">
                Nem todo acompanhamento fica visível aqui — a escola decide o que publicar.
            </p>
        </div>
    </div>
</template>

<script>
/** BLOCO L — item 109 (edital Timbé do Sul): acompanhamentos publicados para o aluno. */
export default {
    name: 'Acompanhamentos',
    data: () => ({
        carregando: false,
        itens: [],
        erro: null
    }),
    mounted () {
        this.carregar()
    },
    methods: {
        carregar () {
            this.carregando = true
            this.erro = null

            // `aluno_id` é injetado pelo middleware portal-aluno a partir do token.
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/portal/acompanhamentos`,
                {},
                this.$store.getters.getHeaderAuth
            ).then(response => {
                const d = response.data || {}

                if (d.erro) {
                    this.erro = typeof d.erro === 'string' ? d.erro : 'Não foi possível carregar os acompanhamentos.'
                    this.itens = []
                } else {
                    this.itens = Array.isArray(d.itens) ? d.itens : []
                }

                this.carregando = false
            }).catch(error => {
                this.carregando = false
                this.$store.commit('throwException', error)
            })
        },
        /** Alguns tipos guardam só o ANO (planos PAEE e PDI), não a data completa. */
        formatarData (d) {
            if (d === null || d === undefined || d === '') return '-'
            const s = String(d)
            if (s.length === 4) return s
            return this.$moment(s).format('DD/MM/YYYY')
        },
        formatarDataHora (d) {
            return d ? this.$moment(d).format('DD/MM/YYYY HH:mm') : '-'
        }
    }
}
</script>
